// extracted by mini-css-extract-plugin
export default {"containerWrapper":"Kontakt_containerWrapper__hiSQz","cardCustom":"Kontakt_cardCustom__ykLBN","sectionButtons":"Kontakt_sectionButtons__-ceV-"};